import { render } from "./ShowAdConsentEditorCmp.vue?vue&type=template&id=4c63333e"
import script from "./ShowAdConsentEditorCmp.vue?vue&type=script&lang=js"
export * from "./ShowAdConsentEditorCmp.vue?vue&type=script&lang=js"

import "./ShowAdConsentEditorCmp.vue?vue&type=style&index=0&id=4c63333e&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__